<template>
  <Card variant="secondary" size="medium">
    <View direction="column" gap="md">
      <View direction="column" gap="xs">
        <Link :to="showingLink" :decoration="false">
          <View direction="row" align="start">
            <View direction="column" gap="xs" :grow="1">
              <Text variant="h5">{{ getShowingTime(props.showing.startTime, props.showing.endTime) }}</Text>
            </View>

            <ShowingStatusLabel v-if="showStatus" :showing-status="props.showing.status" />
            <TourTypeLabel v-if="!showStatus" :tour-type="props.showing.tourType" />
          </View>
        </Link>

        <div>
          <Link :to="propertyLink">
            <Text as="span" variant="body-medium" color="secondary">{{ showing.property.location.address }}</Text>
          </Link>
        </div>
      </View>

      <ShowingRentersList :showing="showing" />

      <template v-if="showShowingRequests && pendingShowingRequests.length">
        <Divider />

        <View direction="column" gap="sm">
          <Text variant="h5" color="secondary">New showing requests</Text>

          <ShowingRequestReviewCard
            v-for="pendingShowingRequest in pendingShowingRequests"
            :key="pendingShowingRequest.id"
            :renter-name="pendingShowingRequest.renter.user.name"
            :renter-id="pendingShowingRequest.renter.id"
            :property-id="showing.property?.id"
            :requested-at="pendingShowingRequest.createdAt"
          />
        </View>
      </template>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Card, Divider, Link, Text, View } from '@tallo/design-system';
import { propertyDashboardRoute, showingDetailsRoute } from '@tallo/investor/navigation';

import { ShowingRequestStatus } from '../interfaces/showing-request-status.enum';
import { ShowingDto } from '../interfaces/showing.interface';
import { getShowingTime } from '../utils/get-showing-time.util';
import ShowingRentersList from './showing-renters-list.vue';
import ShowingRequestReviewCard from './showing-request/showing-request-review-card.vue';
import ShowingStatusLabel from './showing-status-label.vue';
import TourTypeLabel from './tour-type-label.vue';

interface ShowingProps {
  showing: ShowingDto;
  showStatus?: boolean;
  showShowingRequests?: boolean;
  isRenterProfileClickable?: boolean;
}

const props = withDefaults(defineProps<ShowingProps>(), {
  showStatus: true,
  showShowingRequests: true,
});

const showingLink = computed(() => showingDetailsRoute(props.showing.id));
const propertyLink = computed(() => propertyDashboardRoute(props.showing.property.id));

const pendingShowingRequests = computed(() => {
  return props.showing.showingRequests?.filter(({ status }) => status === ShowingRequestStatus.PENDING);
});
</script>

<style scoped lang="scss"></style>
